import React, { useEffect, useState, useMemo } from 'react';
import {
    Box,
    Grid,
    Typography,
    Select,
    MenuItem,
    FormControl,
    // InputLabel,
    // Radio,
    // RadioGroup,
    // FormControlLabel,
    TextField,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    // Chip,
    Checkbox,
    Divider,
} from '@mui/material';

import axios from 'axios';
import { url } from '../../../../../../../../../App';
import Cookies from "js-cookie";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Button } from '@mui/material';
import {
    ToggleButton, ToggleButtonGroup
} from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { toast } from 'react-toastify';
// --- Constants for Styling ---
// const LABEL_COLOR = '#6b7280'; // Gray text for labels
const VALUE_COLOR = '#111827'; // Dark text for values
// const BORDER_COLOR = '#e5e7eb';
// const GREEN_TEXT = '#15803d'; // Dark green for highlights
// const GREEN_BG = '#dcfce7'; // Light green for verified badge

export default function SalaridIncome({ loanid, borrowerData }) {
    const token = Cookies.get("Token");
    const email = Cookies.get("Email");
    const [loandata, setloandata] = useState(null);
    const [remarks, setRemarks] = useState("");
    // const { coapplicant } = borrowerData
    const [coapplicant, setcoapplicant] = useState(borrowerData.coapplicant);
    const [borrowerType, setBorrowerType] = useState('applicant');
    const [incomdetails, setIncomdetails] = useState([]);
    const [salaries, setSalaries] = useState(() =>
        Array.from({ length: 6 }, () => ({
            salary: "",
            remark: ""
        }))
    );
    const handleBorrowerType = (event, newValue) => {
        if (newValue !== null) setBorrowerType("applicant");
    };
    const getIncomeValue = (label) => {
        const item = incomdetails.find(
            (item) => item.label === label
        );

        const value = Number(item?.value ?? 0);
        return Number.isFinite(value) ? value : 0;
    };

    const stats = useMemo(() => {
        const validSalaries = salaries
            ?.map((item) => Number(item?.salary))
            ?.filter((salary) => Number?.isFinite(salary) && salary > 0);

        const creditedMonths = validSalaries?.length;

        if (creditedMonths === 0) {
            return {
                sum: 0,
                average: 0,
                min: 0,
                max: 0,
                creditedMonths: 0,
                stability: {
                    label: "No Data",
                    color: "#9ca3af"
                }
            };
        }

        const sum = validSalaries?.reduce((total, salary) => total + salary, 0);
        const average = Math.round(sum / creditedMonths);
        const min = Math.min(...validSalaries || []);
        const max = Math.max(...validSalaries || []);

        // Assess stability using the variation in credited salaries.
        const variation = average > 0 ? (max - min) / average : 0;

        let stability;

        if (creditedMonths < 6) {
            stability = {
                label: "Insufficient Data",
                color: "#9ca3af"
            };
        } else if (variation <= 0.10) {
            stability = {
                label: "Very Stable",
                color: "#16a34a"
            };
        } else if (variation <= 0.15) {
            stability = {
                label: "Stable",
                color: "#16a34a"
            };
        } else if (variation <= 0.30) {
            stability = {
                label: "Moderate",
                color: "#d97706"
            };
        } else {
            stability = {
                label: "Unstable",
                color: "#dc2626"
            };
        }

        return {
            sum,
            average,
            min,
            max,
            creditedMonths,
            stability
        };
        // eslint-disable-next-line
    }, [salaries, incomdetails]);

    const netMonthlySalary =
        getIncomeValue("Basic Salary") +
        getIncomeValue("H R A") +
        getIncomeValue("Other Allowances") -
        getIncomeValue("PF") -
        getIncomeValue("ESIC") -
        getIncomeValue("Other Dedutions");

    const incomeDetailsToDisplay = [
        ...incomdetails,
        {
            label: "Net Monthly Salary(After Deductions)",
            value: netMonthlySalary,
        },
        {
            label: "Declared Income (From LOS)",
            value: getIncomeValue("Gross Monthly Salary"),
        },
        {
            label: "Average Assessed Income",
            value: stats.average,
        },
        {
            label: "Eligible Primary Income (As per Policy)",
            value: stats.average,
        },
    ];

    // Placeholder constants (use your theme values)
    // const LABEL_COLOR = '#6b7280';
    // const BORDER_COLOR = '#e5e7eb';
    const BLUE = '#2563eb';
    const BLUE_BG = '#eff6ff';
    // Generate last 6 months excluding the current month
    const getLast6Months = () => {
        const months = [];
        const now = new Date();

        for (let i = 6; i >= 1; i--) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            months.push(
                d.toLocaleString("en-US", { month: "short", year: "numeric" })
            );
        }

        return months;
    };
    const [monthLabels, setMonthLabels] = useState(getLast6Months);
    const handleSalaryChange = (index, field, value) => {
        setSalaries((prev) =>
            Array.from({ length: 6 }, (_, i) => {
                const current = prev?.[i] ?? {
                    salary: "",
                    remark: ""
                };

                return i === index
                    ? { ...current, [field]: value }
                    : current;
            })
        );
    };
    // ----- Dynamic Calculations -----
    // Format number with Indian comma style
    const formatCurrency = (num) =>
        num === 0 ? '₹ 0' : `₹ ${Number(num)?.toLocaleString('en-IN')}`;

    // Placeholder constants (define these in your theme or file)
    const BORDER_COLOR = '#e5e7eb';
    const LABEL_COLOR = '#6b7280';
    // const GREEN_TEXT = '#16a34a';


    const details = [
        { label: 'Employer Name', value: borrowerType === "applicant" ? loandata?.employer_name : coapplicant?.[0]?.coapplicant_primary_business_details?.EmployerName },
        { label: 'Designation', value: borrowerType === "applicant" ? loandata?.designation : coapplicant?.[0]?.coapplicant_primary_business_details?.DesignationName },
        { label: 'Industry', value: borrowerType === "applicant" ? loandata?.office_industry : coapplicant?.[0]?.coapplicant_primary_business_details?.Industry },
        {
            label: 'Employment Vintage', value: borrowerType === "applicant" ? loandata?.current_employer_duration :
                coapplicant?.[0]?.coapplicant_primary_business_details?.DurationWithCurrentEmployer
        },
        { label: 'Date of Joining', value: borrowerType === "applicant" ? loandata?.dateofJoining : coapplicant?.[0]?.coapplicant_primary_business_details?.DateOfJoining },
        {
            label: 'Work Location', value: borrowerType === "applicant" ? loandata?.dynamic_data?.work_location : coapplicant?.[0]?.coapplicant_primary_business_details?.Work_Location
        },
        {
            label: 'Pan of Employer', value: borrowerType === "applicant" ? loandata?.dynamic_data?.pan_of_employer : coapplicant?.[0]?.coapplicant_primary_business_details?.Pan_of_Employer

        },

    ];
    const NetInhandApplicant =
        (Number(loandata?.dynamic_data?.Basic_Salary || 0) +
            Number(loandata?.dynamic_data?.HRA_Salary || 0) +
            Number(loandata?.dynamic_data?.other_allowances || 0) -
            (
                Number(loandata?.dynamic_data?.PF_Salary || 0) +
                Number(loandata?.dynamic_data?.ESIC_Salary || 0) +
                Number(loandata?.dynamic_data?.Other_Dedutions_Salary || 0)
            ));

    const coApplicantData =
        coapplicant?.[0]?.coapplicant_primary_business_details;

    const NetInhandCoApplicant =
        (Number(coApplicantData?.Basic_Salary || 0) +
            Number(coApplicantData?.HRA_Salary || 0) +
            Number(coApplicantData?.Allowances || 0)) -
        (
            Number(coApplicantData?.PF_Salary || 0) +
            Number(coApplicantData?.ESIC_Salary || 0) +
            Number(coApplicantData?.Other_Dedutions_Salary || 0)
        );
    const [incomeVerificationDocs, setIncomeVerificationDocs] = useState({
        "Salary Slip": false,
        "Bank Statement": false,
        "Employer Verification": false,
        "Salary Credits": false,
        "ITR (If provided)": false,
    });
    const handleVerificationChange = (title, checked) => {
        setIncomeVerificationDocs((prev) => ({
            ...prev,
            [title]: checked,
        }));
    };

    console.log("NetInhandApplicant:", NetInhandApplicant);
    console.log("NetInhandCoApplicant:", NetInhandCoApplicant);
    useEffect(() => {
        console.log("loandata-> ", loandata)
        console.log("coapplicant-> ", coapplicant)

        const source =
            borrowerType === "applicant"
                ? loandata
                : coapplicant?.[0]?.coapplicant_primary_business_details;

        if (!source && borrowerType === "applicant" && !loandata) return;
        if (!source && borrowerType === "co-applicant" && !coapplicant?.[0]) return;

        const grossSalary =
            borrowerType === "applicant"
                ? loandata?.current_salary
                : source?.Gross_Monthly_Salary;

        setIncomdetails([
            { label: "Gross Monthly Salary", value: String(grossSalary ?? 0) },
            {
                label: "Fixed Salary",
                value: String(
                    (borrowerType === "applicant"
                        ? source?.fixed_salary
                        : source?.Fixed_Salary) ?? 0
                ),
            },
            { label: "Basic Salary", value: String((source?.Basic_Salary || source?.basic_salary) ?? 0) },
            { label: "H R A", value: String((source?.HRA_Salary || source?.hra_salary) ?? 0) },
            { label: "PF", value: String((source?.PF_Salary || source?.pf_salary) ?? 0) },
            { label: "ESIC", value: String((source?.ESIC_Salary || source?.esic_salary) ?? 0) },
            {
                label: "Variable / Incentive",
                value: String(
                    (borrowerType === "applicant"
                        ? source?.Variable_Incentive_salary
                        : source?.Variable_Incentive) ?? 0
                ),
            },
            {
                label: "Other Allowances",
                value: String(
                    (borrowerType === "applicant"
                        ? source?.other_allowances_salary
                        : source?.Allowances) ?? 0
                ),
            },
            {
                label: "Other Dedutions",
                value: String((source?.Other_Dedutions_Salary || source?.other_dedutions_salary) ?? 0),
            },
        ]);
        // eslint-disable-next-line
    }, [borrowerType, loandata, coapplicant]);
    const verificationItems = [
        {
            title: "Salary Slip",
            status: "Verified",
            icon: <DescriptionOutlinedIcon />,
            color: "#1677e8",
            bg: "#eff6ff",
            checkbox: false,
        },
        {
            title: "Bank Statement",
            status: "Verified",
            icon: <AccountBalanceOutlinedIcon />,
            color: "#1677e8",
            bg: "#eff6ff",
            checkbox: false,
        },
        {
            title: "Employer Verification",
            status: "Verified",
            icon: <AccountCircleOutlinedIcon />,
            color: "#2563eb",
            bg: "#eff6ff",
            checkbox: false,
        },
        {
            title: "Salary Credits",
            status: "Matched",
            icon: <CheckCircleOutlineIcon />,
            color: "#16a34a",
            bg: "#ecfdf5",
            checkbox: false,
        },
        {
            title: "ITR (If provided)",
            status: "Not Applicable",
            icon: <ArticleOutlinedIcon />,
            color: "#9ca3af",
            bg: "#f3f4f6",
            checkbox: true,
        },
    ];
    const loadLoandata = async () => {
        if (!loanid) {
            console.log("loanid is missing:", loanid);
            return;
        }

        try {
            const res = await axios.post(url + "/loan/getsingle", {
                token,
                email,
                loan_id: loanid
            });

            console.log("Full API response:", res.data);

            const record = Array.isArray(res.data)
                ? res.data?.[0]
                : res.data?.data?.[0] ?? res.data?.data ?? res.data;

            console.log("Employee record:", record);

            setloandata(record ?? null);

        } catch (err) {
            console.error(
                "API error:",
                err.response?.data || err.message
            );
        }
    };
    const loanCoapplicantdata = async () => {
        if (!loanid) {
            console.log("loanid is missing:", loanid);
            return;
        }

        try {
            const res = await axios.post(
                url + "/coapplicant/getCoapplicantFromLoanId",
                {
                    token,
                    email,
                    loan_id: loanid
                }
            );

            console.log("loanCoapplicantdata response:", res.data);

            const record = Array.isArray(res.data)
                ? res.data?.[0]
                : res.data?.data?.[0] ?? res.data?.data ?? res.data;

            console.log("loanCoapplicantdata record:", record?.message);

            setcoapplicant(record?.message ?? null);

        } catch (err) {
            console.error(
                "API error:",
                err.response?.data || err.message
            );
        }
    };
    useEffect(() => {
        loadLoandata()
        loanCoapplicantdata()
        // eslint-disable-next-line
    }, [loanid, token, email, borrowerType]);
    const updatedata = async (details = incomdetails) => {
        if (!details?.length || !loanid) return;

        try {
            if (borrowerType === "co-applicant") {
                const response = await axios.post(
                    url + "/coapplicant/primary/details/salaried",
                    {
                        token,
                        email,
                        coapplicant_loan_id: loanid,
                        coapplicant_borrower_uniqueno:
                        loandata?.borrower_uniqueno,
                        coapplicant_id: coapplicant?.[0]?.coapplicant_id,
                        coapplicant_primary_business_details: {
                            Gross_Monthly_Salary: details[0]?.value,
                            Fixed_Salary: details[1]?.value,
                            Basic_Salary: details[2]?.value,
                            HRA_Salary: details[3]?.value,
                            PF_Salary: details[4]?.value,
                            ESIC_Salary: details[5]?.value,
                            Variable_Incentive: details[6]?.value,
                            Allowances: details[7]?.value,
                            Other_Dedutions_Salary: details[8]?.value,
                        },
                    }
                );

                if (response.data.auth) {
                    console.log("Co-applicant salary updated");
                } else {
                    toast.error(response.data.message);
                }
            } else if (borrowerType === "applicant") {
                const response = await axios.post(
                    url + "/loan/updatenew",
                    {
                        token,
                        email,
                        loan_id: loanid,
                        borrower_uniqueno: loandata?.borrower_uniqueno,
                        loanproduct_id: loandata?.loanproduct_id,
                        current_salary: details[0]?.value,
                        fixed_salary: details[1]?.value,
                        basic_salary: details[2]?.value,
                        hra_salary: details[3]?.value,
                        pf_salary: details[4]?.value,
                        esic_salary: details[5]?.value,
                        Variable_Incentive_salary: details[6]?.value,
                        other_allowances_salary: details[7]?.value,
                        other_dedutions_salary: details[8]?.value,
                    }
                );

                if (response.data.auth) {
                    console.log("Applicant salary updated");
                } else {
                    toast.error(response.data.message);
                }
            }
        } catch (error) {
            console.error(
                "Salary update error:",
                error.response?.data || error.message
            );
        }
    };
    const handleSaveNext = () => {
        axios.post(url + '/cam/add/salariedIncome', {
            token,
            email,
            loan_id: loanid,
            income_data: {
                borrowerType,
                // incomdetails: incomeDetailsToDisplay,
                salaries,
                monthLabels,
                stats,
                remarks,
                incomeVerificationDocs,
            }
        }).then((res) => {
            if (res.data.auth) {
                toast.success(res?.data?.message)
            }
            else {
                toast.error(res?.data?.message)
            }
        }).catch((err) => {
            console.log(err)
        })
        updatedata()
    };
    useEffect(() => {
        if (!loanid || !token || !email) return;

        let cancelled = false;

        const loadSalaryData = async () => {
            try {
                const res = await axios.post(
                    url + "/cam/get/salariedIncome",
                    {
                        token,
                        email,
                        loan_id: loanid,
                        borrowerType
                    }
                );

                if (cancelled) return;

                const records = res?.data?.data;
                const record = Array.isArray(records)
                    ? records[0]
                    : records;

                if (!record) {
                    setSalaries(
                        Array.from({ length: 6 }, () => ({
                            salary: "",
                            remark: ""
                        }))
                    );
                    setRemarks("");
                    setMonthLabels(getLast6Months());
                    return;
                }

                const savedSalaries = Array.isArray(record.salaries)
                    ? record.salaries
                    : [];

                setSalaries(
                    Array.from({ length: 6 }, (_, index) => {
                        const item = savedSalaries[index];

                        return {
                            salary:
                                item?.salary == null
                                    ? item != null && typeof item !== "object"
                                        ? String(item)
                                        : ""
                                    : String(item.salary),
                            remark: item?.remark ?? ""
                        };
                    })
                );

                setRemarks(record.remarks ?? "");

                if (
                    Array.isArray(record.monthLabels) &&
                    record.monthLabels.length === 6
                ) {
                    setMonthLabels(record.monthLabels);
                } else {
                    setMonthLabels(getLast6Months());
                }
                console.log("record-> ", record)
                setIncomeVerificationDocs(record.incomeVerificationDocs)
            } catch (error) {
                if (!cancelled) {
                    console.error(
                        "Failed to load salary data:",
                        error.response?.data || error.message
                    );
                }
            }
        };

        loadSalaryData();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line
    }, [loanid, token, email, borrowerType]);
    const handleIncomeChange = (label, value) => {
        const updatedDetails = incomdetails.map((item) =>
            item.label === label
                ? { ...item, value }
                : item
        );

        // Update the UI immediately
        setIncomdetails(updatedDetails);

        // Save the latest values to the database
        updatedata(updatedDetails);
    };




    return (
        <Box sx={{ p: 4, bgcolor: '#ffffff', minHeight: '100vh', fontFamily: 'Roboto, sans-serif' }}>
            <Paper elevation={0} sx={{ maxWidth: 1200, mx: 'auto' }}>

                {/* Top Filters */}


                {/* Main Content Grid */}
                <Grid container spacing={4} style={{
                    // backgroundColor:'red'
                    borderRadius: "6px",
                    border: `1px solid ${BORDER_COLOR}`,
                    padding: "1rem"

                }}>
                    <Grid container spacing={3} sx={{ mb: 4 }}>
                        {/* Borrower Type — Segmented Toggle */}
                        <Grid item xs={12} md={3}>
                            <Typography
                                variant="caption"
                                sx={{ color: LABEL_COLOR, fontWeight: 500, display: 'block', mb: 1 }}
                            >
                                Borrower Type *
                            </Typography>

                            <ToggleButtonGroup
                                value={borrowerType}
                                exclusive
                                onChange={handleBorrowerType}
                                fullWidth
                                sx={{
                                    height: '32px',
                                    border: `1px solid ${BORDER_COLOR}`,
                                    borderRadius: 1,
                                    overflow: 'hidden',
                                    '& .MuiToggleButtonGroup-grouped': {
                                        border: 0,
                                        borderRadius: 0,
                                        textTransform: 'none',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        color: '#374151',
                                        px: 1,
                                        py: 0,
                                        gap: 0.75,
                                        '&.Mui-selected': {
                                            color: BLUE,
                                            bgcolor: BLUE_BG,
                                            fontWeight: 600,
                                            '&:hover': { bgcolor: BLUE_BG },
                                        },
                                        '&:not(:first-of-type)': {
                                            borderLeft: `1px solid ${BORDER_COLOR}`,
                                        },
                                    },
                                }}
                            >
                                <ToggleButton value="applicant">
                                    Applicant
                                    {borrowerType === 'applicant'
                                        ? <RadioButtonCheckedIcon sx={{ fontSize: 16, color: BLUE, ml: 1 }} />
                                        : <RadioButtonUncheckedIcon sx={{ fontSize: 16, color: '#9ca3af', ml: 1 }} />
                                    }
                                </ToggleButton>

                                {/* <ToggleButton value="co-applicant">
                                    Co-Applicant
                                    {borrowerType === 'co-applicant'
                                        ? <RadioButtonCheckedIcon sx={{ fontSize: 16, color: BLUE, ml: 1 }} />
                                        : <RadioButtonUncheckedIcon sx={{ fontSize: 16, color: '#9ca3af', ml: 1 }} />
                                    }
                                </ToggleButton> */}
                            </ToggleButtonGroup>
                        </Grid>

                        {/* Income Category */}
                        <Grid item xs={12} md={3}>
                            <Typography variant="caption" sx={{ color: LABEL_COLOR, fontWeight: 500, display: 'block', mb: 1 }}>
                                Income Category *
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select defaultValue="Salaried" sx={{ bgcolor: 'white' }}>
                                    <MenuItem value="Salaried">Salaried</MenuItem>
                                    <MenuItem value="Self-Employed">Self-Employed</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Employment Type */}
                        <Grid item xs={12} md={3}>
                            <Typography variant="caption" sx={{ color: LABEL_COLOR, fontWeight: 500, display: 'block', mb: 1 }}>
                                Employment Type *
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select defaultValue="Permanent" sx={{ bgcolor: 'white' }}>
                                    <MenuItem value="Permanent">Permanent</MenuItem>
                                    <MenuItem value="Contract">Contract</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Employer Category */}
                        <Grid item xs={12} md={3}>
                            <Typography variant="caption" sx={{ color: LABEL_COLOR, fontWeight: 500, display: 'block', mb: 1 }}>
                                Employer Category *
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select defaultValue="MNC / Large" sx={{ bgcolor: 'white' }}>
                                    <MenuItem value="MNC / Large">MNC / Large</MenuItem>
                                    <MenuItem value="SME">SME</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* Left Column: Employment Details */}
                    <Grid item xs={12} md={4}>
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                Employment Details
                            </Typography>
                            <Grid container spacing={1}>
                                {details?.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Grid item xs={5}>
                                            <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                                {item?.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                                :
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2" sx={{ color: VALUE_COLOR, fontWeight: 500 }}>
                                                {item?.value}
                                            </Typography>
                                        </Grid>
                                    </React.Fragment>
                                ))}

                            </Grid>
                        </Box>
                    </Grid>

                    {/* Middle Column: Income Details */}
                    <Grid item xs={12} md={4} sx={{ borderLeft: { md: `1px solid ${BORDER_COLOR}` }, borderRight: { md: `1px solid ${BORDER_COLOR}` }, px: { md: 3 } }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Income Details
                        </Typography>
                        <Box sx={{ overflowY: 'scroll', height: "40vh" }}>
                            {incomeDetailsToDisplay.map((item) => {
                                const isCalculated = [
                                    "Net Monthly Salary(After Deductions)",
                                    "Declared Income (From LOS)",
                                    "Average Assessed Income",
                                    "Eligible Primary Income (As per Policy)",
                                ].includes(item.label);

                                return (
                                    <Box
                                        key={item.label}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 1,
                                            py: 1.2,
                                            borderBottom: `1px solid ${BORDER_COLOR}`,
                                        }}
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {item.label}
                                        </Typography>

                                        <input
                                            type="number"
                                            min="0"
                                            value={item.value ?? 0}
                                            readOnly={isCalculated}
                                            onChange={(e) =>
                                                handleIncomeChange(item.label, e.target.value)
                                            }
                                            placeholder="Enter amount"
                                            style={{
                                                width: "110px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                padding: "5px",
                                                boxSizing: "border-box",
                                                backgroundColor: isCalculated ? "#f3f4f6" : "#fff",
                                                fontWeight: isCalculated ? 600 : 400,
                                            }}
                                        />
                                    </Box>
                                );
                            })}
                        </Box>
                    </Grid>

                    {/* Right Column: Salary Analysis */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                Salary Credit Analysis (Last 6 Months)
                            </Typography>

                            <TableContainer
                                component={Paper}
                                elevation={0}
                                sx={{ border: `1px solid ${BORDER_COLOR}`, borderRadius: 1 }}
                            >
                                <Table size="small">
                                    <TableHead sx={{ bgcolor: '#f3f4f6' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 600, color: '#374151', fontSize: '0.75rem' }}>
                                                Month
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 600, color: '#374151', fontSize: '0.75rem' }}>
                                                Salary Credited (₹)
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 600, color: '#374151', fontSize: '0.75rem' }}>
                                                Remarks
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {monthLabels?.map((month, index) => (
                                            <TableRow key={month}>
                                                <TableCell sx={{ fontSize: '0.8rem', color: '#374151' }}>
                                                    {month}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', color: '#374151' }}>
                                                    {/* {console.log("salaries[index]-> ", salaries?.[index])} */}

                                                    <input
                                                        type="number"
                                                        value={salaries[index]?.salary ?? ""}
                                                        onChange={(e) =>
                                                            handleSalaryChange(index, "salary", e.target.value)
                                                        }
                                                        placeholder="Enter amount"
                                                        style={{
                                                            width: "90px",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "4px",
                                                            padding: "2px 4px",
                                                            boxSizing: "border-box"
                                                        }}
                                                    />


                                                </TableCell>
                                                <TableCell>

                                                    <input
                                                        type="text"
                                                        value={salaries?.[index]?.remark ?? ""}
                                                        onChange={(e) =>
                                                            handleSalaryChange(index, "remark", e.target.value)
                                                        }
                                                        placeholder="Enter remark"
                                                        style={{
                                                            width: "60px",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "4px",
                                                            padding: "2px 4px",
                                                            boxSizing: "border-box"
                                                        }}
                                                    />

                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Summary Section — dynamically calculated */}
                            <Box sx={{ mt: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                        Average Salary Credit
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {formatCurrency(stats.average)}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                        Minimum Salary Credit
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {formatCurrency(stats.min)}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                        Maximum Salary Credit
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {formatCurrency(stats.max)}
                                    </Typography>
                                </Box>
                                <Divider sx={{ my: 1 }} />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                        Salary Credited Months
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {stats.creditedMonths} / 6
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: LABEL_COLOR }}>
                                        Income Stability
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 600, color: stats.stability.color }}
                                    >
                                        {stats.stability.label}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Income verification docs */}

                    <Box sx={{ width: "100%", fontFamily: "Roboto, sans-serif" }}>
                        <Typography
                            sx={{
                                fontSize: "13px",
                                fontWeight: 700,
                                color: "#111827",
                                mb: 1.2,
                            }}
                        >
                            Income Verification
                        </Typography>

                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    sm: "repeat(2, minmax(0, 1fr))",
                                    md: "repeat(5, minmax(0, 1fr))",
                                },
                                gap: 1.8,
                            }}
                        >
                            {verificationItems?.map((item) => (
                                <Paper
                                    key={item?.title}
                                    variant="outlined"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.2,
                                        px: 1.5,
                                        py: 1,
                                        minWidth: 0,
                                        minHeight: 47,
                                        borderRadius: "7px",
                                        borderColor: "#e2e8f0",
                                        boxShadow: "none",
                                        bgcolor: "#fff",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                            width: 32,
                                            height: 32,
                                            borderRadius: "50%",
                                            bgcolor: item.bg,
                                            color: item.color,
                                        }}
                                    >
                                        {React?.cloneElement(item.icon, {
                                            sx: { fontSize: 23 },
                                        })}
                                    </Box>

                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography
                                            sx={{
                                                fontSize: "10.5px",
                                                fontWeight: 600,
                                                color: "#374151",
                                                lineHeight: 1.5,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {item.title}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 500,
                                                color:
                                                    item.status === "Not Applicable"
                                                        ? "#9ca3af"
                                                        : "#16a34a",
                                                lineHeight: 1.5,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {item?.status}
                                        </Typography>
                                        <Checkbox
                                            checked={incomeVerificationDocs?.[item?.title]}
                                            onChange={(event) =>
                                                handleVerificationChange(item?.title, event.target.checked)
                                            }
                                            size="small"
                                            sx={{
                                                color: "#9ca3af",
                                                "&.Mui-checked": {
                                                    color: "#16a34a",
                                                },
                                            }}
                                        />
                                    </Box>
                                </Paper>
                            ))}
                        </Box>
                    </Box>
                    {/* Crdit officer Remark */}
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />

                    <Box
                        sx={{
                            width: "100%",
                            p: 2,
                            border: "1px solid #edf0f5",
                            borderRadius: "6px",
                            bgcolor: "#fff",
                            boxSizing: "border-box",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "11px",
                                fontWeight: 600,
                                color: "#374151",
                                mb: 0.5,
                            }}
                        >
                            Credit Officer Remarks
                        </Typography>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "stretch",
                                gap: 2,
                                flexDirection: { xs: "column", sm: "row" },
                            }}
                        >
                            <TextField
                                fullWidth
                                multiline
                                minRows={1}
                                maxRows={3}
                                placeholder="Enter remarks (if any)"
                                value={remarks}
                                onChange={(event) => setRemarks(event.target.value)}
                                size="small"
                                sx={{
                                    flex: 1,
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "5px",
                                        padding: "7px 10px",
                                        fontSize: "11px",
                                        color: "#374151",
                                        "& fieldset": {
                                            borderColor: "#dfe4ec",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#b8c4d6",
                                        },
                                    },
                                    "& textarea::placeholder": {
                                        color: "#9ca3af",
                                        opacity: 1,
                                    },
                                }}
                            />

                            <Button
                                variant="contained"
                                onClick={handleSaveNext}
                                endIcon={<ChevronRightIcon />}
                                sx={{
                                    minWidth: { xs: "100%", sm: 124 },
                                    height: 31,
                                    alignSelf: { xs: "stretch", sm: "center" },
                                    borderRadius: "4px",
                                    textTransform: "none",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                    bgcolor: "#0755d9",
                                    boxShadow: "none",
                                    "&:hover": {
                                        bgcolor: "#0646b5",
                                        boxShadow: "none",
                                    },
                                }}
                            >
                                Save &amp; Next
                            </Button>
                        </Box>
                    </Box>

                </Grid>
                {/* <hr /> */}

            </Paper>
        </Box>
    );
}